import { createSlice } from "@reduxjs/toolkit"

import type { RootState } from "redux/store"

export const initialState = {
  code: null,
}

export const verificationSlice = createSlice({
  name: "verification",
  initialState,
  reducers: {
    start: (state, { payload }) => {
      state.code = payload.code
    },
    reset: () => {
      return initialState
    },
  },
})

export const { start, reset } = verificationSlice.actions

export const selectCode = (state: RootState) => state.features.verification.code

export default verificationSlice.reducer
